import Axios from 'axios'

import { beforeSend } from './interceptors/request/beforeSend.interceptor'
import { beforeSendError } from './interceptors/request/beforeSendError.interceptor'
import { beforeReceive } from './interceptors/response/beforeReceive.interceptor'
import { beforeReceiveError } from './interceptors/response/beforeReceiveError.interceptor'

const createAxiosInstance = () => {
  const axiosInstance = Axios.create({
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
    timeout: 20000,
    withCredentials: true,
  })
  delete axiosInstance.defaults.headers.common.Authorization
  return axiosInstance
}

export const AxiosInstance = createAxiosInstance()
export const NoInterceptorAxiosInstance = createAxiosInstance()

// This just to enable tests without worrying about the token
if (process.env.NODE_ENV !== 'test') {
  AxiosInstance.interceptors.request.use(beforeSend, beforeSendError)
  AxiosInstance.interceptors.response.use(beforeReceive, beforeReceiveError)
}
